<template>
  <div class="sidebar" :class="{ 'sidebar--closed': !isSideBarOpen }">
    <div class="sidebar-content">
      <router-link
        tag="img"
        class="sidebar-content__logo cursor-pointer"
        :src="require('@/assets/images/instacash-logo-white.svg')"
        to="/"
      />

      <menu-content></menu-content>

      <div
        @click="isSideBarOpen = !isSideBarOpen"
        class="sidebar-toggle"
        :class="{ 'sidebar-toggle--closed': !isSideBarOpen }"
      >
        <b-icon icon="chevron-left" type="is-white" size="is-small"> </b-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      isSideBarOpen: true,
    };
  },
  components: {
    MenuContent: () => import("@/components/MenuContent.vue"),
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
</style>
